import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { Button, Slide } from '@material-ui/core';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
}

export default function SnackbarComponent({ open, onClose, msg }) {
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={TransitionUp}
      open={open}
      // autoHideDuration={4000}
      onClose={onClose}
      ContentProps={{
        'aria-describedby': 'snackbar-fab-message-id',
      }}
      message={<span id="snackbar-fab-message-id">{msg}</span>}
      action={
        <Button color="inherit" size="small" onClick={onClose}>
          close
        </Button>
      }
    />
  );
}
